import loadable from '@loadable/component';

const TechnologiesPage = loadable(() => import('./page'));
const TechnologyDashboardPage = loadable(() => import('./[id]/page'));

export const routes = [
  {
    path: '',
    element: <TechnologiesPage />,
  },
  {
    path: ':id',
    element: <TechnologyDashboardPage />,
  },
];
